<template>
    <v-main class="pa-2" fluid>
        <h1>Users</h1>
        <v-toolbar flat>
            <v-dialog v-model="dialog" @keydown.esc="dialog = false" persistent max-width="900px">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark v-on="on">Add new User</v-btn>
                </template>
                <v-card color="lighten-1">
                    <v-toolbar>
                        <v-toolbar-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-container>
                            <v-form ref="form" v-model="valid">
                                <v-row>
                                    <v-col cols="12" md="12">
                                        <v-text-field label="Name" v-model="editedItem.name" :rules="nameRules"
                                            required></v-text-field>

                                        <v-text-field :disabled="editedIndex > -1" type="email" label="Email"
                                            v-model="editedItem.email" :rules="emailRules" @change="resetForm"
                                            :error-messages="emailErrorMsg" required></v-text-field>



                                        <v-text-field v-if="editedIndex === -1" label="Password" hint="6 or + characters"
                                            persistent-hint v-model="editedItem.password" :rules="passwordRules" counter
                                            required></v-text-field>
                                        <!-- && !isAdmin -->
                                        <v-select v-if="(editedIndex > -1) || editedIndex === -1" v-model="editedItem.roles"
                                            :items="roles" item-disabled="disabled" item-text="title" item-value="name"
                                            label="Roles" multiple chips hint="Add or remove roles to this user"
                                            persistent-hint @change="checkMainRoles"></v-select>



                                        <v-select v-if="isInstructor" v-model="editedItem.instructor"
                                            :items="instructorObjs" label="Select an Instructor" item-text="name"
                                            item-value="id" :rules="nameRules"></v-select>

                                        <v-select v-if="isPilot" v-model="editedItem.pilot" :items="pilotObjs"
                                            item-text="name" item-value="id" label="Select a Pilot"
                                            :rules="nameRules"></v-select>

                                        <v-select v-if="isPacker" v-model="editedItem.packer" :items="packerObjs"
                                            item-text="name" item-value="id" label="Select a Packer"
                                            :rules="nameRules"></v-select>
                                    </v-col>


                                </v-row>

                            </v-form>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                        <v-btn color="blue darken-1" type="submit" @click="save" :disabled="!valid">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-spacer></v-spacer>
            <v-btn class="blue--text" to="/wages" link><v-icon>mdi-chart-box</v-icon> &nbsp; Wages</v-btn>
        </v-toolbar>

        <v-dialog v-model="tasksDialog" @keydown.esc="tasksDialog = false" persistent max-width="900px">

            <v-card color="lighten-1">
                <v-toolbar>
                    <v-toolbar-title>
                        <span class="headline">Task's prices for {{ editedItem.name }}</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <v-form ref="form" v-model="valid">
                            <v-row>

                                <v-col cols="12" md="12">
                                    <v-select v-model="editedItem.tasks" :items="tasks" item-text="name" label="Tasks"
                                        multiple chips hint="Add or remove tasks to this user" persistent-hint
                                        return-object></v-select>


                                </v-col>
                            </v-row>
                            <v-col cols="12" md="12">
                                <v-row>
                                    <v-col col="6" md="6">
                                        <v-subheader>Fixed Price Tasks</v-subheader>


                                        <v-row class="inline-numberfield-list" v-if="editedItem.tasks.length > 0"
                                            v-for="task in editedItem.tasks" :value="task.name" :key="task.id">
                                            <v-col cols="4" md="4" v-if="task.type != 'hr'">
                                                <v-label>{{ task.name }}</v-label>
                                            </v-col>
                                            <v-col cols="4" md="4" v-if="task.type != 'hr'">
                                                <v-text-field type="number" :hint="task.type" v-model.number="task.price"
                                                    :rules="nameRules" required persistent-hint
                                                    prepend-icon="mdi-currency-usd"></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col col="6" md="6">
                                        <v-row>
                                            <v-col cols="4" md="4">
                                                <v-label>Hourly Rate</v-label>
                                            </v-col>
                                            <v-col cols="6" md="6">
                                                <v-text-field type="number" v-model.number="editedItem.hourly_rate"
                                                    prepend-icon="mdi-currency-usd"></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>

                            </v-col>

                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    <v-btn color="blue darken-1" type="submit" @click="saveTasks" :disabled="!valid">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-data-table :headers="headers" :items="users" :items-per-page="50" class="elevation-1">
            <template v-slot:item.actions="{ item }">

                <v-btn icon small @click="edit(item)">
                    <v-icon center>mdi-pencil</v-icon>
                </v-btn>

                <v-btn icon small @click="editTasks(item)">
                    <v-icon center>mdi-account-cash</v-icon>
                </v-btn>

                <v-btn icon small @click="resetPassword(item.id)">
                    <v-icon center>mdi-lock-reset</v-icon>
                </v-btn>
                <v-btn icon small class="red--text" @click="deleteUser(item.id)"><v-icon>mdi-delete-forever</v-icon></v-btn>

            </template>

            <template v-slot:item.status="{ item }">
                <v-switch :success="item.status == 1 ? true : false" @change="updateStatus(item)" v-model="item.status"
                    inset :label="getUserSwitchLabel(item.status)"></v-switch>
            </template>
        </v-data-table>
    </v-main>
</template>

<script>
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'


export default {
    data() {
        return {
            headers: [
                { text: '', value: 'data-table-expand' },
                { text: 'Name', align: 'start', sortable: true, value: 'name', },
                { text: 'Roles', align: 'start', sortable: true, value: 'roles', },
                { text: '', align: 'start', sortable: true, value: 'status' },
                { text: '', align: 'start', sortable: true, value: 'actions' },
            ],

            dialog: false,
            tasksDialog: false,
            editedIndex: -1,
            valid: true,
            lazy: true,
            isEditing: null,
            editedItem: {
                name: '',
                status: true,
                email: '',
                status: 1,
                roles: [],
                password: '',
                client_id: null,
                instructor: null,
                packer: null,
                pilot: null,
                hourly_rate: 0,
                tasks: []

            },
            nameRules: [
                v => !!v || ' Required',
            ],

            emailRules: [
                v => !!v || 'Email is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid'
            ],

            passwordRules: [
                v => !!v || 'Password is required',
                v => (v && v.length >= 6) || 'Password must have 6+ characters'
            ],


            emailErrorMsg: "",

            isInstructor: false,
            isPilot: false,
            isPacker: false

        }
    },

    mounted() {

        this.$store.dispatch('fetchUsers')
        this.$store.dispatch('fetchRoles')
        this.$store.dispatch('fetchInstructors')
        this.$store.dispatch('fetchPackers')
        this.$store.dispatch('fetchPilots')
        this.$store.dispatch('fetchTasks')
    },


    computed: {

        ...mapState(['users', 'roles', 'uuid', 'instructors', 'pilots', 'packers', 'tasks']),
        ...mapGetters(['role_names', 'emails']),


        packerObjs() {

            let selectablePackers = this.packers.filter(function (i) {
                    return i.user_id == null
                })

            if (this.editedIndex == -1) {

                return selectablePackers
            } else {
                let currentPacker = this.packers.filter(p => p.user_id == this.editedItem.id)

                return currentPacker.length == 1 ? currentPacker : selectablePackers
            }


        },

        instructorObjs() {
            let selectableInstructors = this.instructors.filter(function (i) {
                    return i.user_id == null
                })

            if (this.editedIndex == -1) {
                return selectableInstructors
            } else {

                let currentInstructor = this.instructors.filter(p => p.user_id == this.editedItem.id)

                return  currentInstructor.length == 1 ? currentInstructor : selectableInstructors
            }
        },

        pilotObjs() {

            let selectablePilots = this.pilots.filter(function (i) {
                    return i.user_id == null
                })

            if (this.editedIndex == -1) {

                return selectablePilots
            } else {
                let currentPilot = this.pilots.filter(p => p.user_id == this.editedItem.id)
                 return currentPilot.length == 1 ? currentPilot : selectablePilots
            }



        },

        isAdmin() {

            return this.editedItem.roles.includes('admin')

        },

        formTitle() {
            return this.editedIndex === -1 ? 'New User' : 'Edit User'
        },


    },

    watch: {
        dialog(val) {
            val || this.close()
        },


    },

    methods: {

        checkMainRoles(val) {

            this.isInstructor = val.includes('instructor') && !this.editedItem.instructor
            this.isPilot = val.includes('pilot') && !this.editedItem.pilot
            this.isPacker = val.includes('packer') && !this.editedItem.packer

        },


        resetForm() {

            if (this.emailErrorMsg !== "")
                this.$refs.form.resetValidation()
            this.emailErrorMsg = ""
            this.valid = true
        },


        isEmailUnique() {

            return this.emails.includes(this.editedItem.email)

        },

        edit(item) {
            this.editedIndex = this.users.indexOf(item)
            this.editedItem = Object.assign({}, item)



            this.roles.map(function (r) {

                if (r.name == 'instructor' && item.roles.includes('instructor'))
                    r.disabled = true

                if (r.name == 'pilot' && item.roles.includes('pilot'))
                    r.disabled = true


                if (r.name == 'packer' && item.roles.includes('packer'))
                    r.disabled = true

            })

            this.isPacker = item.roles.includes('packer')
            this.isInstructor = item.roles.includes('instructor')
            this.isPilot = item.roles.includes('pilot')


            this.dialog = true

        },

        editTasks(item) {

            this.editedIndex = this.users.indexOf(item)
            this.editedItem = Object.assign({}, item)

            item.tasks.map(function (t) {
                if (t.pivot)
                    t.price = t.pivot.price
            })

            this.tasksDialog = true

        },


        close() {

            this.isInstructor = false
            this.isPilot = false
            this.isPacker = false

            this.roles.map(function (r) { r.disabled = false })
            this.tasks.map(function (t) { t.price = 0 })
            this.dialog = false
            this.tasksDialog = false

            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1

            })
        },


        save() {

            if (this.editedIndex === -1 && this.emails.includes(this.editedItem.email)) {


                this.emailErrorMsg = "This email has been used"


            } else {

                this.editedItem.client_id = this.uuid


                if (this.editedIndex > -1) {


                    axios.put('/api/users/' + this.editedItem.id, this.editedItem)
                        .then(response => {

                            Object.assign(this.users[this.editedIndex], this.editedItem)
                            this.$store.dispatch('fetchUsers')
                            this.close();

                        })
                        .catch(err => {
                            console.log(err)
                        })


                } else {


                    axios.post('/api/users', this.editedItem)
                        .then(response => {

                            this.users.push(this.editedItem)
                            this.$store.dispatch('fetchUsers')
                            this.close();

                        })
                        .catch(err => {
                            console.log(err)
                        })

                }

            }

        },


        saveTasks() {


            axios.put('/api/users/updateTasks/' + this.editedItem.id, this.editedItem)
                .then(response => {

                    this.$store.dispatch('fetchUsers')

                    this.close()

                })
                .catch(err => {
                    console.log(err)
                })

        },

        resetPassword(id) {

            const newPwd = prompt('Enter new password')

            if (newPwd) {
                axios.put('/api/users/resetPassword/' + id, { 'password': newPwd })
                    .then(response => {

                        this.close()

                    })
                    .catch(err => {
                        console.log(err)
                    })
            }


        },

        updateStatus(item) {

            this.editedIndex = this.users.indexOf(item)
            this.editedItem = Object.assign({}, item)

            axios.put('/api/users/updateStatus/' + this.editedItem.id, this.editedItem)
                .then(response => {

                    this.close()

                })
                .catch(err => {
                    console.log(err)
                })

        },


        deleteUser(id) {

            confirm('Are you sure you want to delete this User? This action can not be undone') &&

                axios.delete('/api/users/' + id)
                    .then(response => {

                        const index = this.users.map(function (f) { return f.id }).indexOf(id)

                        this.$store.state.users.splice(index, 1)
                    })
                    .catch(err => {
                        console.log(err)
                    })
        }
    }
}
</script>